<template>
<a href="/personal/cart/" class="h_link_basket basketline basketline--mobile teas" v-cloak>
    <span v-if="cnt">{{ cnt }}</span>
</a>
</template>

<script>
export default {
    name: 'BasketMobile',
    computed : {
        cnt : () => vxCommonStore.state.productsInCart.length,
    },
}
</script>
